import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Container from '../atoms/Container';
import EmbedContainer from '../atoms/EmbedContainer';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import _uniqueId from 'lodash/uniqueId';

gsap.registerPlugin( ScrollTrigger );

const Holder = styled.div`
  background-color: ${props => props.theme.colours.grey};
  padding: 2rem 0;
  @media( ${props => props.theme.breakpoints.md} ) {
    padding: 4rem 0;
  }
`;

const Inner = styled.div`
  margin: 0 auto;
  max-width: 60rem;
`;

function Video( { url } ) {
  const [ id, setId ] = useState( null );
  const holder = useRef( null );
  const tl = useRef( null );

  useEffect(() => {
    setId( _uniqueId( 'two-col-' ) );
  }, []);

  useEffect( () => {
    if ( !tl.current && id ) {

      tl.current = ScrollTrigger.matchMedia( {
        // desktop
        '(min-width: 576px)': function () {
          gsap.timeline( {
            scrollTrigger: {
              trigger: holder.current,
              start: 'top 75%',
              end: 'top 25%',
              scrub: true,
            }
          } )
          .from( `#${id}`, {
            y: 50,
            autoAlpha: 0,
            duration: 1,
          } );

        }
      } );
    }
  }, [ id ] );
  return (
    <Holder ref={holder}>
      <Container uniqueId={id}>
        <Inner>
          <EmbedContainer>
            <video
              autoPlay
              muted
              loop
              playsInline
              controls={false}>
              <source src={url} type="video/mp4"/>
              Your browser does not support the video tag.
            </video>
          </EmbedContainer>
        </Inner>
      </Container>
    </Holder>
  )
}

Video.propTypes = {
  url: PropTypes.string
};

export default Video;
